import Ajv from 'ajv';
import addFormats from 'ajv-formats';

const setValidateEmail = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => validateEmail());
  } else {
    validateEmail();
  }
};

const validateEmail = () => {
  const validateTarget = document.getElementById(
    'organization_user_email'
  ) as HTMLInputElement | null;
  if (!validateTarget) return;

  const ajv = new Ajv();
  addFormats(ajv);

  const validate = ajv.compile({
    type: 'string',
    format: 'email',
  });

  const errorMessage = document.createElement('div');
  errorMessage.className = 'p-loginForm__invailed';
  errorMessage.textContent = '＊メールアドレスが無効です。';
  validateTarget.insertAdjacentElement('afterend', errorMessage);
  errorMessage.style.display = 'none';

  validateTarget.addEventListener('blur', () => {
    const email = validateTarget.value.trim();
    const isValid = validate(email);

    if (email === '' || isValid) {
      validateTarget.classList.remove('isInvailed');
      errorMessage.style.display = 'none';
    } else {
      validateTarget.classList.add('isInvailed');
      errorMessage.style.display = 'block';
    }
  });
};

setValidateEmail();

// 管理画面ログイン: パスワード表示切替
const setupPasswordToggle = () => {
  const toggleBtn = document.querySelector<HTMLElement>('.p-adminLogin__passwordToggle');
  if (!toggleBtn) return;

  const passwordInput = toggleBtn
    .closest('.p-adminLogin__passwordWrap')
    ?.querySelector<HTMLInputElement>('.p-adminLogin__input--password');
  if (!passwordInput) return;

  toggleBtn.addEventListener('click', () => {
    const isPassword = passwordInput.type === 'password';
    passwordInput.type = isPassword ? 'text' : 'password';
    toggleBtn.classList.toggle('is-visible', isPassword);
    toggleBtn.setAttribute('aria-label', isPassword ? 'パスワードを非表示' : 'パスワードを表示');
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupPasswordToggle);
} else {
  setupPasswordToggle();
}
